import type { ComponentType } from "react";

import { BankImportAgentPanel } from "./BankImportAgentPanel";
import type { AgentPanel } from "./runner/types";
import { SortAssistantAgentPanel } from "./SortAssistantAgentPanel";
import { UploadAgentPanel } from "./UploadAgentPanel";

export interface AgentPanelProps {
    panel: AgentPanel;
    onDone(result: "done" | "skipped"): void;
}

/** Inline panels by type: upload, sort assistant and bank import. */
export const agentPanels: Partial<Record<AgentPanel["type"], ComponentType<AgentPanelProps>>> = {
    upload: UploadAgentPanel,
    sortAssistant: SortAssistantAgentPanel,
    bankImport: BankImportAgentPanel,
};
